import React from "react";
import AnimatedPage from "./AnimatedPage";
import { useState } from "react";
import axios from "axios";

function UploadTopics({ isAuthenticated, loading, setLoading }) {
  const [topicsField, setTopics] = useState("");
  const uploadTopics = () => {
    setLoading(true);
    axios
      .post("https://api.hemenparekh.ai/dashboard/topics", {
        topics: topicsField,
      })
      .then((res) => {
        console.log(res);
        setLoading(false);
        console.log(!loading);
        alert("Topics uploaded successfully!");
        setTopics("");
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
        console.log(!loading);
        alert("Error uploading topics!");
      });
  };
  return (
    isAuthenticated && (
      <AnimatedPage>
        <div className="main-container">
          <h1>Upload Topics</h1>
          <h3 className="note">
            Reminder: Make sure that each new topic is placed on a separate
            line.
          </h3>
          <textarea
            value={topicsField}
            onChange={(e) => {
              setTopics(e.target.value);
            }}
            rows="24"
            placeholder="Enter topics here..."
          ></textarea>
          <button
            onClick={() => {
              // const topics = topicsField.split("\n");
              // console.log(topics);
              uploadTopics();
            }}
          >
            Submit
          </button>
        </div>
      </AnimatedPage>
    )
  );
}

export default UploadTopics;
